import { fetchBackend } from './apiClient';

export type MessageHistory = {
  content: string;
  role: 'user' | 'assistant';
}[];

export const chatWithAnnieBackend = async ({
  projectId,
  prompt,
  conversationId,
  history,
  messageId,
}: {
  projectId: string;
  prompt: string;
  conversationId: string;
  history: MessageHistory;
  messageId: string;
}): Promise<void> => {
  const postResponse = await fetchBackend(
    `/frontend-chatbot/${projectId}/chat-frontend`,
    {
      method: 'POST',
      body: JSON.stringify({
        prompt,
        conversation_id: conversationId,
        source: 'frontend',
        history,
        message_id: messageId,
      }),
    },
  );

  if (!postResponse.ok) {
    throw new Error(`Error: ${postResponse.statusText}`);
  }
};
